import clsx from 'clsx';
import { ReactNode, forwardRef } from 'react';
import { ButtonVariantProps, buttonClasses } from './Button.styles';
import { ButtonContent } from './ButtonContent';

/* -------------------------------------------------------------------------------------------------
 * Button
 * -----------------------------------------------------------------------------------------------*/

type ButtonElement = React.ElementRef<'button'>;

export interface ButtonProps
  extends React.ComponentPropsWithoutRef<'button'>, ButtonVariantProps {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const Button = forwardRef<ButtonElement, ButtonProps>(
  (
    { className, type = 'button', leftIcon, rightIcon, children, ...props },
    forwardedRef,
  ) => {
    const contentProps = { rightIcon, leftIcon, children };
    const { wide: _, ...buttonProps } = props;

    return (
      <button
        {...buttonProps}
        type={type}
        className={clsx(buttonClasses(props), className)}
        aria-disabled={buttonProps.disabled ? true : undefined}
        data-variant={props.variant}
        ref={forwardedRef}
      >
        <ButtonContent {...contentProps} />
      </button>
    );
  },
);

Button.displayName = 'Button';
